const project = (project = null, action) => {
  switch (action.type) {
    case "SET_PROJECT":
      return action.project;
    default:
      return project;
  }
};
export default project;
